import React, { useState, useEffect, useRef } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import useStyles from './pillOutline.styles';
/* eslint no-tabs: ['error', { allowIndentationTabs: true }] */
const DEFAULT_ICON_SIZE = 44;
const PillOutlineSVG = (props) => {
	const classes = useStyles();
	const {
		width,
		text,
		// iconSize,
		onTextMatrixChange,
	} = props;
	const textRef = useRef();
	const [transformMatrix, setTransformMatrix] = useState('matrix(1 0 0 1 115 28.5142)');

	useEffect(() => {
        onTextMatrixChange(transformMatrix);
    }, [transformMatrix]);

	useEffect(() => {
		if (textRef.current) {
			const text = textRef.current;
			const tbox = text.getBBox();
			const newX = (118 - tbox.width / 2);
			// const newY = ((iconSize - tbox.height) / 2);
			const translation = 'matrix(1 0 0 1 ' + newX + ' 28.5142)';
			setTransformMatrix(translation);
		}
	}, [textRef.current, width, text]);
	return (
		<svg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink' x='0px' y='0px'
			viewBox='0 0 204 48' style={{ 'enable-background': 'new 0 0 204 48' }} xmlSpace='preserve'>
			<g>
				<path className={classes.st0} d='M23.6,47.4c-12.8,0-23.1-10.5-23.1-23.5S10.9,0.4,23.6,0.4h156.8c12.8,0,23.1,10.5,23.1,23.5
		s-10.4,23.5-23.1,23.5H23.6z'/>
				<path className={classes.st1} d='M180.4,0.9c12.5,0,22.6,10.3,22.6,23s-10.1,23-22.6,23H23.6C11.1,46.9,1,36.6,1,23.9s10.1-23,22.6-23
		L180.4,0.9 M180.4-0.1H23.6C10.6-0.1,0,10.6,0,23.9s10.6,24,23.6,24h156.8c13,0,23.6-10.8,23.6-24S193.4-0.1,180.4-0.1L180.4-0.1z'
				/>
			</g>
			<circle className={classes.st0} cx='23.7' cy='23.9' r='20' />
			<defs>
			    <linearGradient id='monoLinear1' x1='0' y1='0' x2='1' y2='0' gradientUnits='userSpaceOnUse' gradientTransform='matrix(-103,0,-0,-178.01613,164,57.752659)'>
			        <stop offset='0' style={{ stopColor: 'white', stopOpacity: 1 }} />
			        <stop offset='1' style={{ stopColor: 'rgb(179,179,179)', stopOpacity: 1 }} />
			    </linearGradient>
			    <linearGradient id='monoLinear2' x1='0' y1='0' x2='1' y2='0' gradientUnits='userSpaceOnUse' gradientTransform='matrix(104.098721,0,0,161.004363,59.901279,54.62662)'>
			        <stop offset='0' style={{ stopColor: 'white', stopOpacity: 1 }} />
			        <stop offset='1' style={{ stopColor: 'rgb(179,179,179)', stopOpacity: 1 }} />
			    </linearGradient>
			    <linearGradient id='monoLinear3' x1='0' y1='0' x2='1' y2='0' gradientUnits='userSpaceOnUse' gradientTransform='matrix(-103,0,-0,-178.785995,164,57.752659)'>
			        <stop offset='0' style={{ stopColor: 'white', stopOpacity: 1 }} />
			        <stop offset='1' style={{ stopColor: 'rgb(179,179,179)', stopOpacity: 1 }} />
			    </linearGradient>
			</defs>
			<g transform='translate(10.5 15) scale(0.18)'>
			    <g transform='translate(-287.009995 -55.65802)'>
			        <g transform='translate(263 3)'>
			            <g transform='matrix(1.027215,0,0,0.594346,-23.804988,100.522251)'>
			                <path d='M164,57.753C164,73.07 156.805,85.505 147.942,85.505L77.058,85.505C68.195,85.505 61,73.07 61,57.753C61,42.436 68.195,30 77.058,30L147.942,30C156.805,30 164,42.436 164,57.753Z' style={{ fill: 'url(#monoLinear1)' }} />
			            </g>
			        </g>
			        <g transform='translate(263 3)'>
			            <g transform='matrix(0.919245,0,0,0.594346,-32.063975,67.532896)'>
			                <path d='M164,57.753C164,73.07 155.96,85.505 146.056,85.505L78.944,85.505C69.04,85.505 61,73.07 61,57.753C61,42.436 69.04,30 78.944,30L146.056,30C155.96,30 164,42.436 164,57.753Z' style={{ fill: 'url(#monoLinear2)' }} />
			            </g>
			        </g>
			        <g transform='translate(263 3)'>
			            <g transform='matrix(1.027215,0,0,0.591787,-4.463251,34.904425)'>
			                <path d='M164,57.753C164,73.07 156.836,85.505 148.011,85.505L76.989,85.505C68.164,85.505 61,73.07 61,57.753C61,42.436 68.164,30 76.989,30L148.011,30C156.836,30 164,42.436 164,57.753Z' style={{ fill: 'url(#monoLinear3)' }} />
			            </g>
			        </g>
			    </g>
			</g>
			<rect x='55.9' y='17.5' className={classes.st3} width='129.1' height='13.5' />
			<text ref={textRef} transform={transformMatrix} className={classNames([classes.st1, classes.st4, classes.st5])}>{props.text}</text>
		</svg>

	);
};

PillOutlineSVG.propTypes = {
	width: PropTypes.number,
	text: PropTypes.string,
	iconSize: PropTypes.number,
	onTextMatrixChange: PropTypes.func,
};

PillOutlineSVG.defaultProps = {
	width: 250,
	text: 'Sync to Calendar',
	iconSize: DEFAULT_ICON_SIZE,
	onTextMatrixChange: () => {},
};

export default PillOutlineSVG;
